"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var CreateNewFolder = function CreateNewFolder(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/file/create_new_folder-create-new-folder" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-create-new-folder" + unique,
    xlinkHref: "#path-1-create-new-folder" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-create-new-folder" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,12 L16,9.5 C16,9.22385763 15.7761424,9 15.5,9 L14.5,9 C14.2238576,9 14,9.22385763 14,9.5 L14,12 L11.5,12 C11.2238576,12 11,12.2238576 11,12.5 L11,13.5 C11,13.7761424 11.2238576,14 11.5,14 L14,14 L14,16.5 C14,16.7761424 14.2238576,17 14.5,17 L15.5,17 C15.7761424,17 16,16.7761424 16,16.5 L16,14 L18.5,14 C18.7761424,14 19,13.7761424 19,13.5 L19,12.5 C19,12.2238576 18.7761424,12 18.5,12 L16,12 Z M3,4 L10,4 L12,6 L21,6 C21.5522847,6 22,6.44771525 22,7 L22,19 C22,19.5522847 21.5522847,20 21,20 L3,20 C2.44771525,20 2,19.5522847 2,19 L2,5 C2,4.44771525 2.44771525,4 3,4 Z",
    fill: "inherit",
    id: "path-1-create-new-folder" + unique
  }))));
};

CreateNewFolder.propTypes = propTypes;
var _default = CreateNewFolder;
exports["default"] = _default;